//api方法封装
import axios from 'axios';
import qs from "qs";


axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/app-api' : process.env.VUE_APP_BASE_API;


//  注册
export function register(data) {
  const url = '/member/auth/register'
  return axios.post(url, data, {
    headers: {
    'Content-Type': 'application/json',
    'tenant-id': 162
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

//  发送手机验证码
export function sendCode(data) {
  const url = '/member/auth/send-sms-code'
  return axios.post(url, data, {
    headers: {
    'Content-Type': 'application/json',
    'tenant-id': 162
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 查询名字是否存在
export function checkName(name) {
  const url = '/member/auth/validate-username'
  return axios.get(url + '?username=' + name, {
    headers: {
      'tenant-id': 162
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}